/* v80: step labels before a path is chosen ("Bikes", "Dates" instead of "…"). Loads after yb-1..4. */
(function(){
  if (typeof stepper !== 'function' || typeof S === 'undefined') return;
  var orig = stepper;
  stepper = function(){
    if (S.flow) return orig.apply(this, arguments);
    var el = document.getElementById('yb-stepper'); if (!el) return;
    el.innerHTML = ['Demo or hire','Bikes','Dates','Your details'].map(function(l,i){
      return '<div class="yb-step'+(i===S.step?' on':'')+'"><span class="n">'+(i+1)+'</span>'+l+'</div>';
    }).join('');
  };
  try { var el = document.getElementById('yb-stepper'); if (!S.flow && el && el.innerHTML) stepper(); } catch(e){}
})();

/* v83: open straight on a path when the section says so (demo page = bikes first, hire page = dates first).
   A link's own ?type= or an assistant ?hold= still wins. yb-3 renders once the day rules load, after this runs. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || typeof S === 'undefined') return;
  var f = root.getAttribute('data-start-flow');
  var q = new URLSearchParams(location.search);
  if (q.get('hold') || q.get('type')) return;
  if (f !== 'demo' && f !== 'hire') return;
  S.flow = f; S.step = 1;
  try { stepper(); } catch(e){}
  /* if the day rules already loaded and the chooser rendered, redraw on the chosen path */
  try { if (!document.querySelector('#yb-view .yb-msg')) render(); } catch(e){}
})();

/* v84: bike photos on the booking list. Each row gets a thumbnail (from the section's "Bike photo" blocks,
   matched on the model name); tap it to see the photo big. Rows are redrawn often, so a MutationObserver re-adds them. */
(function(){
  var data = document.getElementById('yb-photos'), view = document.getElementById('yb-view');
  if (!data || !view) return;
  var P = {};
  try { JSON.parse(data.textContent).forEach(function(p){ if (p && p.m && p.t) P[String(p.m).trim().toLowerCase()] = p; }); } catch(e){ return; }
  function attr(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }
  function open(src, name){
    var o = document.createElement('div');
    o.className = 'yb-lightbox'; o.setAttribute('role','dialog'); o.setAttribute('aria-label', name);
    o.innerHTML = '<img src="'+attr(src)+'" alt="'+attr(name)+'"><button type="button" aria-label="Close">&times;</button>';
    function close(){ o.remove(); document.removeEventListener('keydown', key); }
    function key(e){ if (e.key === 'Escape') close(); }
    o.addEventListener('click', close);
    document.addEventListener('keydown', key);
    document.body.appendChild(o);
  }
  function decorate(){
    [].forEach.call(view.querySelectorAll('.yb-model'), function(row){
      if (row.querySelector('.yb-thumb')) return;
      var h = row.querySelector('h3'); if (!h) return;
      var name = h.textContent.trim(), p = P[name.toLowerCase()]; if (!p) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'yb-thumb'; b.setAttribute('aria-label', 'See a bigger photo of the ' + name);
      b.innerHTML = '<img src="'+attr(p.t)+'" alt="Yeti '+attr(name)+'" loading="lazy">';
      b.addEventListener('click', function(){ open(p.f || p.t, 'Yeti ' + name); });
      row.insertBefore(b, row.firstChild);
      row.classList.add('has-thumb');
    });
  }
  new MutationObserver(decorate).observe(view, { childList: true, subtree: true });
  decorate();
})();

/* v84: on the demo and hire pages the path is already chosen, so the steps drop "Demo or hire":
   demo = Choose bikes · Pick dates · Your details; hire = Pick dates · Choose bikes · Your details.
   Going "back" past the first step returns to the page's own first step (never the demo/hire chooser),
   and the first step has no Back button. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || typeof S === 'undefined') return;
  var f = root.getAttribute('data-start-flow');
  if (f !== 'demo' && f !== 'hire') return;
  if (new URLSearchParams(location.search).get('hold')) return;
  var LAB = { demo:['Choose bikes','Pick dates','Your details'], hire:['Pick dates','Choose bikes','Your details'], slot:['Pick a time','Choose a bike','Your details'] };
  var prevStepper = stepper;
  stepper = function(){
    if (!S.flow || !LAB[S.flow] || S.step < 1) return prevStepper.apply(this, arguments);
    var el = document.getElementById('yb-stepper'); if (!el) return;
    el.innerHTML = LAB[S.flow].map(function(l,i){
      return '<div class="yb-step'+(i === S.step-1 ? ' on' : '')+'"><span class="n">'+(i+1)+'</span>'+l+'</div>';
    }).join('');
  };
  var prevGo = go;
  go = function(n){
    if (n <= 0) { S.flow = f; S.cart = []; S.start = S.end = null; S.slot = null; S.slotDay = null; n = 1; }
    return prevGo(n);
  };
  var prevRender = render;
  render = function(){
    var r = prevRender.apply(this, arguments);
    if (S.flow === f && S.step === 1) { var b = document.getElementById('yb-back'); if (b) b.style.display = 'none'; }
    return r;
  };
  try { stepper(); } catch(e){}
})();

/* v86: range extender add-on, hire flow only, one tick per e-bike.
   The Hub's /availability sends extender {day_cents, kinds:{tq:{fits:'MTe',...}, bosch:{fits:'LTe',...}}};
   /hold takes extender: [bike ids]. Names and price come from the Hub. */
(function(){
  if (typeof S === 'undefined' || typeof api !== 'function') return;
  S.extenders = {}; S.ext = null;
  var st = document.createElement('style');
  st.textContent = '#yeti-booking .yb-ext{display:flex;gap:10px;align-items:flex-start;margin:4px 0 10px;padding:10px 12px;border:1px solid rgba(0,0,0,.14);border-radius:10px;cursor:pointer;background:#fff}'+
    '#yeti-booking .yb-ext input{margin-top:3px;width:18px;height:18px;flex:none}'+
    '#yeti-booking .yb-ext b{display:block;font-size:14px}'+
    '#yeti-booking .yb-ext small{display:block;font-size:13px;line-height:1.4;opacity:.75;margin-top:3px}'+
    '#yeti-booking .yb-ext.off{cursor:default;opacity:.6}'+
    '#yeti-booking .yb-ci.yb-ci-ext{font-size:.92em}';
  document.head.appendChild(st);
  function dayC(){ return (S.ext && S.ext.day_cents) || 2000; }
  function kindFor(b){
    var k = S.ext && S.ext.kinds; if (!k) return null;
    var m = modelOf(b);
    for (var key in k) if (k[key] && k[key].fits === m) return k[key];
    return null;
  }
  function ticked(){
    if (S.flow !== 'hire' || !days()) return [];
    return S.cart.filter(function(c){ var k = kindFor(c); return S.extenders[c.id] && k && k.available; });
  }
  function prune(){ var keep = {}; S.cart.forEach(function(c){ if (S.extenders[c.id]) keep[c.id] = true; }); S.extenders = keep; }
  var prevApi = api;
  api = function(path, opts){
    var p = String(path);
    if (p.indexOf('/hold') === 0 && opts && opts.method === 'POST' && S.flow === 'hire') {
      try { var b = JSON.parse(opts.body); if (b.type === 'hire') { var ex = ticked().map(function(c){ return c.id; }); if (ex.length) b.extender = ex; else delete b.extender; opts = Object.assign({}, opts, { body: JSON.stringify(b) }); } } catch(e){}
    }
    var r = prevApi(path, opts);
    if (p.indexOf('/availability?type=hire') === 0) {
      r = r.then(function(j){
        S.ext = j.extender || null;
        S.cart.forEach(function(c){ var k = kindFor(c); if (!k || !k.available) delete S.extenders[c.id]; });
        setTimeout(function(){ if (S.flow === 'hire') drawCart(); }, 0);
        return j;
      });
    }
    return r;
  };
  var prevCharge = chargeCents;
  chargeCents = function(){ var c = prevCharge.apply(this, arguments); return c ? c + ticked().length * dayC() * days() : c; };
  var prevDraw = drawCart;
  drawCart = function(){
    prune();
    var r = prevDraw.apply(this, arguments);
    if (S.flow !== 'hire' || !S.ext || !S.ext.kinds) return r;
    var rows = document.querySelectorAll('#yb-cartwrap .yb-cart > .yb-ci');
    var d = days(), on = ticked();
    S.cart.forEach(function(c, i){
      var k = kindFor(c), row = rows[i]; if (!k || !k.offered || !row) return;
      var html = '';
      if (on.indexOf(c) >= 0) html += '<div class="yb-ci yb-ci-ext"><span>Range extender for '+esc(c.displayName)+' · '+money(dayC())+' × '+d+(d === 1 ? ' day' : ' days')+'</span><span class="yb-cip">'+money(dayC()*d)+'</span></div>';
      if (S.step !== 3) html += '<label class="yb-ext'+(k.available ? '' : ' off')+'"><input type="checkbox" data-ext="'+esc(c.id)+'"'+(on.indexOf(c) >= 0 ? ' checked' : '')+(k.available ? '' : ' disabled')+'>'+
        '<span><b>Add a range extender · +'+money(dayC())+' a day</b><small>'+(k.available ? esc(k.label)+' for the '+esc(k.fits)+'. Clips onto the frame for the big days; out with the bike, back with the bike.' : 'Already out on those dates')+'</small></span></label>';
      if (!html) return;
      var box = document.createElement('div'); box.innerHTML = html;
      var after = row;
      while (box.firstChild) { var n = box.firstChild; after.parentNode.insertBefore(n, after.nextSibling); after = n; }
    });
    [].forEach.call(document.querySelectorAll('#yb-cartwrap input[data-ext]'), function(ck){
      ck.onchange = function(){ if (ck.checked) S.extenders[ck.dataset.ext] = true; else delete S.extenders[ck.dataset.ext]; drawCart(); };
    });
    return r;
  };
  var prevGo2 = go;
  go = function(n){ if (n <= 0) S.extenders = {}; return prevGo2(n); };
})();

/* v90: hire page — short demos days and hire-only bikes.
   A short demos day (half-day slot day) is off for the demo fleet. If the Hub says hire_ok:false it is
   crossed out and can't be picked. If hire_ok:true (some bikes are hire only) the day stays open: the
   dates step shows a soft note and the bike list greys the demo fleet with the Hub's reason.
   Bikes with hireOnly:true get a "Hire only" line every day. Everything keys off the Hub's flags
   (hire_ok, hire_only_day, hireOnly), never bike names or dates. */
(function(){
  var root = document.getElementById('yeti-booking');
  if (!root || root.getAttribute('data-start-flow') !== 'hire' || typeof month !== 'function' || typeof rDates !== 'function') return;
  var st = document.createElement('style');
  st.textContent = '#yeti-booking .yb-day.reserved{cursor:not-allowed;color:var(--yb-mut,#8a949c);text-decoration:line-through;opacity:.55}'+
    '#yeti-booking #yb-next:disabled{display:none}'+
    '#yeti-booking .yb-reserved-note{margin:10px 0 0;font-size:13px;color:var(--yb-mut,#5f6b73)}'+
    '#yeti-booking .yb-softnote{margin:12px 0 0;padding:10px 12px;border-left:3px solid var(--yb-accent,#00a0af);background:rgba(0,160,175,.07);font-size:14px;line-height:1.5}'+
    '#yeti-booking .yb-hireonly{margin:6px 0 0;font-size:13px;font-weight:600;color:var(--yb-accent,#00a0af)}';
  document.head.appendChild(st);
  function hireOk(d){ var r = rule(d); return !(r && r.mode === 'slots' && r.hire_ok !== true); }
  function isSlot(d){ var r = rule(d); return !!(r && r.mode === 'slots'); }
  function andList(a){ return a.length < 2 ? a.join('') : a.slice(0, -1).join('; ') + ' and ' + a[a.length - 1]; }

  var prevMonth = month;
  month = function(){
    var el = prevMonth.apply(this, arguments);
    if (S.flow !== 'hire') return el;
    [].forEach.call(el.querySelectorAll('.yb-day.slot'), function(c){
      var r = rule(c.dataset.d), lb = r && r.label ? ' · ' + r.label : '';
      if (hireOk(c.dataset.d)) { c.title = 'Demo day — hire-only bikes only' + lb; }
      else { c.classList.add('reserved'); c.onclick = null; c.title = 'Demo day — no hires' + lb; }
    });
    return el;
  };

  var prevDates = rDates;
  rDates = function(){
    var out = prevDates.apply(this, arguments);
    if (S.flow !== 'hire') return out;
    var cal = document.getElementById('yb-cal');
    var key = document.querySelector('#yb-view .yb-key');
    if (key) key.innerHTML = key.innerHTML.replace('short demos day', cal && cal.querySelector('.yb-day.slot:not(.reserved)') ? 'demo day (hire-only bikes)' : 'reserved for demo days');
    if (cal && cal.querySelector('.yb-day.reserved') && !document.querySelector('.yb-reserved-note')) {
      var p = document.createElement('p'); p.className = 'yb-reserved-note';
      p.textContent = 'Crossed-out days are reserved for demoing (busy weekends and events), so they can’t be booked for hire.';
      cal.insertAdjacentElement('afterend', p);
    }
    var w = document.getElementById('yb-toslot');
    if (!w) return out;
    var box = w.closest('.yb-warn'), sd = rangeDays().filter(isSlot);
    var blocked = sd.filter(function(d){ return !hireOk(d); }), soft = sd.filter(hireOk);
    if (blocked.length) {
      box.innerHTML = andList(blocked.map(fmt)) + (blocked.length > 1 ? ' are' : ' is') + ' reserved for demoing, so a hire can’t include ' + (blocked.length > 1 ? 'them' : 'it') + '. Pick dates either side.';
      return out;
    }
    if (soft.length) {
      box.className = 'yb-softnote';
      box.innerHTML = andList(soft.map(fmt)) + (soft.length > 1 ? ' are short demos days' : ' is a short demos day') + ' — only our hire-only bikes go out ' + (soft.length > 1 ? 'those days' : 'that day') + '. They’re marked below.';
      var nb = document.getElementById('yb-next');
      if (nb) { nb.disabled = false; nb.onclick = function(){ go(S.step + 1); }; }
    }
    return out;
  };

  /* Show the Hub's own reason when it isn't one the base page knows (e.g. "demo day — no hires"). */
  var prevWhy = whyText;
  whyText = function(b){
    if (b && b.why && /demo day/i.test(b.why)) return b.why.charAt(0).toUpperCase() + b.why.slice(1);
    return prevWhy.apply(this, arguments);
  };

  /* "Hire only" line under any model that has hire-only sizes. */
  function tagHireOnly(){
    if (S.flow !== 'hire' || !S.bikes) return;
    [].forEach.call(document.querySelectorAll('#yb-list .yb-model'), function(row){
      if (row.querySelector('.yb-hireonly')) return;
      var ids = [].map.call(row.querySelectorAll('.yb-size'), function(b){ return b.dataset.id; });
      var bs = S.bikes.filter(function(b){ return ids.indexOf(b.id) >= 0; });
      var ho = bs.filter(function(b){ return b.hireOnly === true; });
      if (!ho.length) return;
      var all = ho.length === bs.length;
      var d = document.createElement('div'); d.className = 'yb-hireonly';
      d.textContent = 'Hire only' + (all ? '' : ' (' + ho.map(function(b){ return sizeOf(b); }).join(', ') + ')') + ' — not available as a demo.';
      var mi = row.querySelector('.yb-mi'); if (mi) mi.appendChild(d);
    });
  }
  var list = document.getElementById('yb-view') || root;
  new MutationObserver(tagHireOnly).observe(list, { childList: true, subtree: true });

  /* Heads-up box: when the next short demos day still lets hire-only bikes out, say so. */
  if (typeof slotNotice === 'function') {
    var prevNotice = slotNotice, hoNames = null;
    slotNotice = function(){
      var out = prevNotice.apply(this, arguments);
      var box = document.getElementById('yb-slotnotice'); if (!box) return out;
      var g = typeof slotGroups === 'function' ? slotGroups() : [];
      if (!g.length) return out;
      var first = g[0], r = rule(first.start);
      if (!(r && r.hire_only_day === true)) return out;
      var p = box.querySelector('.yb-slotnote p'); if (!p) return out;
      var name = first.label ? first.label : 'These days';
      var weekend = first.start !== first.end ? 'a demo weekend' : 'a demo day';
      var like = hoNames && hoNames.length ? ' (like the ' + hoNames.join(', ') + ')' : '';
      p.innerHTML = esc(name) + ' is ' + weekend + ' — the demo fleet goes out in half-day slots, but our hire-only bikes' + like + ' are still available to hire. Want to try a bike that weekend? Book a half-day demo.';
      if (hoNames === null) {
        hoNames = [];
        api('/bikes?type=hire').then(function(x){
          var seen = {};
          (x.bikes || []).forEach(function(b){ if (b.hireOnly === true && b.status !== 'retired') { var m = modelOf(b); if (!seen[m]) { seen[m] = 1; hoNames.push(m); } } });
          if (hoNames.length) slotNotice();
        }).catch(function(){});
      }
      return out;
    };
    try { slotNotice(); } catch (e) {}
  }
})();

/* v87: free-demo codes. The code box also takes a free-demo code from the Hub (/code answers free:true).
   With one on, a one-day demo or a half-day slot shows $0 and books straight through: the Hub confirms it
   and sends no cart lines, so the page shows "You're booked" instead of going to checkout. Hires aren't covered. */
(function(){
  if (typeof S === 'undefined' || typeof lmCheck !== 'function' || typeof lmHtml !== 'function') return;
  S.lmFree = false; S.freeHold = null;
  var st = document.createElement('style');
  st.textContent = '#yeti-booking .yb-free{margin:8px 0 4px;font-size:14px;font-weight:600;color:var(--yb-accent,#00a0af)}'+
    '#yeti-booking .yb-cart.is-free .yb-cip{text-decoration:line-through;opacity:.55}'+
    '#yeti-booking .yb-booked dl{display:grid;grid-template-columns:auto 1fr;gap:6px 16px;margin:18px 0}'+
    '#yeti-booking .yb-lm-hint{margin:6px 0 0;font-size:12.5px;opacity:.7}#yeti-booking .yb-booked dt{opacity:.7}#yeti-booking .yb-booked dd{margin:0;font-weight:600}';
  document.head.appendChild(st);
  function freeOn(){ return !!(S.lmCode && S.lmFree); }
  function covered(){ return freeOn() && (S.flow === 'slot' || (S.flow === 'demo' && S.start && S.start === S.end)); }
  var prevCheck = lmCheck;
  lmCheck = function(){ S.lmFree = false; return prevCheck.apply(this, arguments).then(function(r){ S.lmFree = !!(r && r.free); return r; }); };
  var prevHtml = lmHtml;
  lmHtml = function(){
    if (freeOn()) return '<div class="yb-lm on"><span>✓ Code accepted — this demo is on us. One day, or a half-day on a short demos day. You can book from ' + (LEAD_DAYS === 0 ? 'today' : fmt(iso(firstBookable()))) + '.</span> <button type="button" class="yb-lm-x">Remove</button></div>';
    return prevHtml.apply(this, arguments).replace('Have a last-minute code?', 'Have a code from us?').replace('<div class="yb-lm-msg"', '<p class="yb-lm-hint">Got two codes from us? Type both, with a space between.</p><div class="yb-lm-msg"');
  };
  var prevCharge = chargeCents;
  chargeCents = function(){ return covered() ? 0 : prevCharge.apply(this, arguments); };
  var prevDraw = drawCart;
  drawCart = function(){
    var r = prevDraw.apply(this, arguments);
    if (!freeOn()) return r;
    var cart = document.querySelector('#yb-cartwrap .yb-cart'); if (!cart) return r;
    var note = '';
    if (S.flow === 'hire') note = 'Free-demo codes don’t cover hires.';
    else if (covered()) { note = 'Free with your code'; cart.classList.add('is-free'); var brk = cart.querySelector('.yb-tot + .yb-note'); if (brk) brk.remove(); }
    else if (S.flow === 'demo' && S.start && S.end) note = 'Your code covers one day — pick a single day to make it free.';
    if (note) { var p = document.createElement('div'); p.className = 'yb-free'; p.textContent = note; var at = cart.querySelector('.yb-tot'); cart.insertBefore(p, at ? at.nextSibling : cart.querySelector('#yb-cont')); }
    return r;
  };
  var prevApi = api;
  api = function(path, opts){
    var p = String(path), isHold = /^\/hold(\?|$)/.test(p) && opts && opts.method === 'POST', r = prevApi(path, opts);
    if (isHold) r = r.then(function(j){ S.freeHold = (j && j.free) ? j : null; return j; });
    if (/^\/hold\//.test(p) && !(opts && opts.method === 'POST')) r = r.then(function(j){
      setTimeout(function(){ var h = view && view.querySelector('h1'); if (h && /already paid/i.test(h.textContent)) h.textContent = 'This booking is confirmed'; }, 0);
      return j; });
    return r;
  };
  var prevCheckout = toCheckout;
  toCheckout = function(){
    var h = S.freeHold; if (!h) return prevCheckout.apply(this, arguments);
    S.freeHold = null;
    var when = S.flow === 'slot' && S.slot ? fmt(S.slotDay) + ', ' + hm(S.slot.start) + '–' + hm(S.slot.end) : (S.start === S.end ? fmt(S.start) : rangeTxt());
    var bikes = S.cart.map(function(c){ return esc(c.displayName); }).join(S.flow === 'demo' && S.cart.length > 1 ? ' + ' : ', ');
    var st = document.getElementById('yb-stepper'); if (st) st.innerHTML = '';
    view.innerHTML = '<div class="yb-booked"><h1>You’re booked — nothing to pay.</h1>'+
      '<dl><dt>Booking</dt><dd>' + esc(h.bookingNumber || '') + '</dd><dt>' + (S.cart.length > 1 ? 'Bikes' : 'Bike') + '</dt><dd>' + bikes + '</dd><dt>When</dt><dd>' + esc(when) + '</dd></dl>'+
      '<p class="yb-sub">Bring photo ID to pick up.</p>'+
      '<p class="yb-sub">Pickup at the Yeti Showroom, 1131 Amohau Street, Rotorua.</p>'+
      (h.bookingNumber && h.token ? '<p><a class="yb-mg-link" href="/pages/book?manage=' + encodeURIComponent(h.bookingNumber) + '&t=' + encodeURIComponent(h.token) + '">Change or cancel this booking</a></p>' : (h.link ? '<p><a class="yb-btn" href="' + esc(h.link) + '">View your booking</a></p>' : '')) + '</div>';
    try { view.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch(e){}
    return Promise.resolve();
  };
})();
